module.exports = __webpack_public_path__ + "static/img/port (2).82d3df1f.png";